<template>
  <div class="item-dimension" v-bind="$attrs">
    <div class="item-dimension-input" :class="{'is-error': status,'not-error':statusInput.height || statusInput.width}">
      <!-- 注意这里用 model.value.width -->
      <InputNumber
        placeholder="Height"
        style="width: 90px"
        :error="false"
        :hide-button="true"
        :min="0"
        @focus="statusInput.height=true"
        @blur="handleBlur"
        v-model="localHeight"
        append="X"
      />
      <InputNumber
        placeholder="Width"
        style="width: 90px"
        :error="false"
        :hide-button="true"
        :min="0"
        @focus="statusInput.width=true"
        @blur="handleBlur"
        v-model="localWidth"
        append="mm"
      />
      <span class="item-dimension-input-unit" @click="handleUnit" v-if="inch">
        inch↔mm
      </span>
    </div>
    <Modal
      v-model:visible="visible"
      title="Inch ⇒ mm Conversion"
      ok-text="submit"
      @ok="submit"
      :hide-cancel="true"
    >
      <p>
        If you enter in units of inches and press the [Convert] button, it will
        be converted into units of millimeters in the quotation form.
      </p>
      <div
      class="not-error"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 30px;
        "
      >
        <InputNumber
          :hide-button="true"
          :min="0"
          v-model="dialogModel.width"
          append="inch"
          :error="false"
          prepend="X="
        />
        <InputNumber
          :hide-button="true"
          :min="0"
          v-model="dialogModel.height"
          append="inch"
          :error="false"
          prepend="Y="
        />
      </div>
    </Modal>
  </div>
</template>

<script setup>
import { InputNumber, Modal } from "@arco-design/web-vue";
import { ref, unref,computed,inject,reactive,nextTick,triggerRef,watch } from "vue";
import { formItemInjectionKey } from "@arco-design/web-vue/es/form/context";
const formItemCtx = inject(formItemInjectionKey, null);
const statusInput=reactive({
  height:false,
  width:false,
})
const status = computed(() => {
  return formItemCtx?.error&&(!statusInput.height && !statusInput.width);
});
const props = defineProps({
  heightProp: {
    type: String,
    default: "BoardHeight",
  },
  widthProp: {
    type: String,
    default: "BoardWidth",
  },
  inch:{
    type:Boolean,
    default:true,
  }
});
const visible = ref(false);
const emits = defineEmits(["change", "update:modelValue"]);

defineOptions({
  name: "item-dimension",
  inheritAttrs: false,
});

// 弹窗里的输入数据
const dialogModel = ref({
  width: null,
  height: null,
});

const handleUnit = () => {
  visible.value = true;
};

const formData = defineModel("form");

// 本地 ref 管理高度和宽度值
const localHeight = ref(null);
const localWidth = ref(null);

// 初始化本地值
localHeight.value = formData.value?.[props.heightProp] ?? null;
localWidth.value = formData.value?.[props.widthProp] ?? null;

// 标记，避免循环更新
let isUpdatingFromExternal = false;
let isUpdatingFromLocal = false;

// 监听外部 formData 的变化，同步到本地值
watch(
  () => formData.value,
  (newFormData) => {
    if (newFormData && !isUpdatingFromLocal) {
      isUpdatingFromExternal = true;
      // 只有当值真的不同时才更新，避免循环
      if (localHeight.value !== newFormData[props.heightProp]) {
        localHeight.value = newFormData[props.heightProp];
      }
      if (localWidth.value !== newFormData[props.widthProp]) {
        localWidth.value = newFormData[props.widthProp];
      }
      nextTick(() => {
        isUpdatingFromExternal = false;
      });
    }
  },
  { deep: true }
);

// 监听本地值的变化，同步到 formData
watch([localHeight, localWidth], () => {
  if (!formData.value || isUpdatingFromExternal) return;
  
  isUpdatingFromLocal = true;
  
  // 更新 formData
  formData.value[props.heightProp] = localHeight.value;
  formData.value[props.widthProp] = localWidth.value;
  
  // 手动触发 ref 更新，确保父组件同步
  triggerRef(formData);
  
  // 触发 change 事件
  nextTick(() => {
    emits("change", formData.value);
    isUpdatingFromLocal = false;
  });
});

function submit() {
  // 单位转换：inch 转 mm
  localHeight.value = Number(
    (dialogModel.value.width * 25.4).toFixed(2)
  );
  localWidth.value = Number(
    (dialogModel.value.height * 25.4).toFixed(2)
  );
  // watch 会自动同步到 formData
}

// 离开输入框时只重置 focus 状态，不触发 change
const handleBlur = (e) => {
  // 重置所有 focus 状态
  statusInput.height = false;
  statusInput.width = false;
};
</script>

<style scoped lang="less">
.is-error{
  &:deep(.arco-input-wrapper){
    -webkit-animation: pcb-glow 800ms ease-out infinite alternate;
    animation: pcb-glow 800ms ease-out infinite alternate;
  }
}
.not-error{
  &:deep(.arco-input-wrapper){
    border:1px solid #DFE1E6 !important;
    &:deep(.arco-input-wrapper){
    -webkit-animation: none;
    animation: none;
  }
  }
}
.item-dimension {
  max-width: 500px;
}
.item-dimension-input {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.item-dimension-input-unit {
  margin-left: 10px;
  width: 70px;
  /* background-image:linear-gradient(to right,#FFFFFF,#E4E4E4);  */
  margin-left: 10px;
  padding: 5px 10px;
  background: #ffffff;
  color: #333333;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #cccccc;
  text-align: center;
  cursor: pointer;
}
:deep(.arco-input-append) {
  background-color: #f5f5f5;
}
:deep(.arco-input-wrapper) {
  padding-left: 7px !important;
  padding-right: 7px !important;
  border-radius: 0px;
  color: #333333 !important;
  height: 28px !important;
}
:deep(.arco-input-append) {
  padding: 0px !important;
  min-width: 28px !important;
  text-align: center !important;
  color: #666666 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0 !important;
  font-size: 12px !important;
  padding: 3px !important;
}
:deep(.arco-input-number) {
  border-radius: 0 !important;
}
:deep(.arco-input-outer) {
  border-radius: 0 !important;
}
:deep(.arco-input-number) {
  /* border: 1px solid #CCCCCC !important; */
}
</style>
